let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aa9pX")).then(() => parcelRequire('jFo4x'));